import {  useState } from "react";
import { Button, Modal } from "react-bootstrap";


const ModalSucursal = (props) => {
    const {
        estado,
        onCloseModal,
        onReturnValue,
        defaultValue,
        isNew
    } = props;
    const [formData3, setValue] = useState(defaultValue);
    const handleSubmit2 = (event) => {
        event.preventDefault();
        onReturnValue(formData3,isNew);
    }
    return (
        <>

            <Modal
                show={estado}
                onHide={onCloseModal}

            >

                <Modal.Header closeButton>
                    <Modal.Title>Agregar Sucursal</Modal.Title>
                </Modal.Header>
                <Modal.Body>

                    <form onSubmit={handleSubmit2}
                     >
                      
                        <div className="form-group mb-2 row">
                            <label className="col-form-label">
                               Codigo
                                <span className="text-danger">*</span>
                            </label>
                            <div className="">
                                <input
                                    type="text"
                                    className="form-control"
                                    value={formData3.codigo}
                                    required
                                    onChange={e => { setValue({ ...formData3, codigo: e.target.value }) }}
                                  

                                />
                            </div>
                        </div>
                        <div className="form-group mb-2 row">
                            <label className="col-form-label">
                                Sucursal
                                <span className="text-danger">*</span>
                            </label>
                            <div className="">
                                <input
                                    type="text"
                                    className="form-control"
                                    required
                                    value={formData3.nombre}
                                    onChange={e => { setValue({ ...formData3, nombre: e.target.value }) }}
                                  

                                />
                            </div>
                        </div>
                        <div className="form-group mb-2 row">
                            <label className="col-form-label">
                               Direccion
                                <span className="text-danger">*</span>
                            </label>
                            <div className="">
                                <input
                                    type="text"
                                    className="form-control"
                                    required
                                    value={formData3.direccion}
                                    onChange={e => { setValue({ ...formData3, direccion: e.target.value }) }}
                                  

                                />
                            </div>
                        </div>
                        <div className="form-group mb-2 row">
                            <label className="col-form-label">
                              Telefono
                                <span className="text-danger">*</span>
                            </label>
                            <div className="">
                                <input
                                    type="text"
                                    className="form-control"
                                    required
                                    value={formData3.telefono}
                                    onChange={e => { setValue({ ...formData3, telefono: e.target.value }) }}
                                  

                                />
                            </div>
                        </div>
                      
                        <Button variant="danger" onClick={onCloseModal}>
                        Cerrar
                    </Button>
                    <Button type="submit" >
                        Guardar
                    </Button>
                        

                    </form>





                </Modal.Body>
               
            </Modal>


        </>
    );
}

export default ModalSucursal;